import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { Patient } from '~/domain/patient/patient';
import {
    patientRepositoryState,
    selectedPatientIdState,
} from '~/state/atoms/patientAtoms';

export default function useSelectedPatient() {
    const patientRepository = useRecoilValue(patientRepositoryState);
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const [selectedPatient, setSelectedPatient] = useState<Patient>();
    useEffect(() => {
        const allPatients: Patient[] = patientRepository.getAll();
        const patient = allPatients?.find(
            (patient) => patient.dataSet.PatientID === selectedPatientId
        );
        if (patient) {
            setSelectedPatient(patient);
        } else {
            setSelectedPatient(undefined);
        }
    }, [selectedPatientId]);

    return selectedPatient;
}
